(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-shelves"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var lanes = [];
    var state = { cat: '__all', rars: [], lo: null, hi: null, sort: 'manual' };

    /* ===== Bloxcart-style inline quantity stepper for [data-bxc-add] cards.
       Replaces the old "click -> spinner -> checkmark -> revert to Add"
       flow (which showed nothing for the length of a full network
       round-trip) with an instant optimistic swap to minus/qty/plus,
       matching the pattern already proven for the hero carousel. This
       store re-issues a fresh cart line key on every cart write, so the key
       is always re-read from the latest response rather than cached once. ===== */
    var bxcMinusSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M5 12h14"/></svg>';
    var bxcPlusSvg = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
    var bxcAddLabel = {};
    var bxcLineKey = {};
    var bxcPendingAdd = {};
    var bxcTimers = {};
    function bxcAddBtnHTML(vid, label) { return '<button type="button" class="bxc-card__add" data-bxc-add data-vid="' + vid + '"><span class="bxc-add-lbl">' + label + '</span><span class="bxc-add-spin" aria-hidden="true"><svg class="bxc-spinner" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><circle cx="12" cy="12" r="9" stroke-opacity="0.25"/><path d="M21 12a9 9 0 0 0-9-9" stroke-linecap="round"/></svg></span></button>'; }
    function bxcQtyHTML(vid, qty) { return '<div class="bxc-qty" data-bxc-qty data-vid="' + vid + '"><button type="button" class="bxc-qty__btn bxc-qty__plus" data-bxc-plus aria-label="زيادة">' + bxcPlusSvg + '</button><span class="bxc-qty__n" data-bxc-n>' + qty + '</span><button type="button" class="bxc-qty__btn bxc-qty__minus" data-bxc-minus aria-label="إنقاص">' + bxcMinusSvg + '</button></div>'; }
    function bxcFrag(html) { var d = document.createElement('div'); d.innerHTML = html; return d.firstChild; }
    /* What the cart will really hold after this add. bxc-minqty.js clamps an add
       up to a per-variant minimum (exposed as __zzMinForKey) and doubles BOGO
       variants, which bxc-card.liquid marks with .bxc-card__bogo. Computing it
       up front means the stepper can show the true quantity instead of always
       "1", and lets the add go out as a single absolute-quantity write. */
    function bxcWantQty(vid, card) {
      var min = 0;
      try { min = (window.__zzMinForKey && window.__zzMinForKey(String(vid))) || 0; } catch (e) { min = 0; }
      var q = min > 1 ? min : 1;
      if (card && card.querySelector('.bxc-card__bogo')) q = q * 2;
      return q;
    }
    /* /cart/add.js returns only the line it just added, with no cart totals, so
       the floating cart had to chase it with a second /cart.js GET -- two serial
       round trips before the pill total and drawer could show the truth.
       /cart/update.js sets an absolute quantity and returns the FULL cart, so a
       single round trip updates everything, and zz-floating-cart commits that
       response directly instead of re-fetching. Called without `want` only as a
       fallback when a change is requested for a line whose key was lost. */
    function bxcStartLine(vid, want) {
      var updates = {};
      updates[vid] = want || 1;
      bxcBusyStart(vid);
      var p = fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: updates }) })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          bxcBusyEnd(vid);
          /* Rejected (a quantity cap returns 422). Re-read the real cart rather
             than leaving the optimistic number on screen until a reload. */
          if (!cart) { bxcSyncCartQty(); return null; }
          var item = cart.items && cart.items.filter(function (it) { return String(it.variant_id) === String(vid); }).pop();
          bxcLineKey[vid] = item ? item.key : null;
          bxcApplyCart(cart);
          return bxcLineKey[vid];
        })
        .catch(function () { bxcBusyEnd(vid); bxcSyncCartQty(); return null; });
      bxcPendingAdd[vid] = p;
      return p;
    }
    function bxcGetKey(vid) {
      if (bxcLineKey[vid]) return Promise.resolve(bxcLineKey[vid]);
      return bxcPendingAdd[vid] || bxcStartLine(vid);
    }
    function bxcSendChange(vid, qty) {
      return bxcGetKey(vid).then(function (key) {
        if (!key) return;
        bxcBusyStart(vid);
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (data) {
            bxcBusyEnd(vid);
            /* Rejected (a quantity cap returns 422). Re-read the real cart so the
               stepper cannot keep showing a number the server never accepted. */
            if (!data) { bxcSyncCartQty(); return; }
            if (qty <= 0) { bxcLineKey[vid] = null; }
            else {
              var item = data.items && data.items.filter(function (it) { return String(it.variant_id) === String(vid); }).pop();
              bxcLineKey[vid] = item ? item.key : key;
              document.dispatchEvent(new CustomEvent('bxc:cart-updated'));
            }
            bxcApplyCart(data);
          })
          .catch(function () { bxcBusyEnd(vid); bxcSyncCartQty(); });
      });
    }
    function bxcDebounceChange(vid, qty) {
      if (bxcTimers[vid]) clearTimeout(bxcTimers[vid]);
      bxcTimers[vid] = setTimeout(function () { delete bxcTimers[vid]; bxcSendChange(vid, qty); }, 300);
    }
    function bxcImmediateChange(vid, qty) {
      if (bxcTimers[vid]) { clearTimeout(bxcTimers[vid]); delete bxcTimers[vid]; }
      return bxcSendChange(vid, qty);
    }
    /* Cart state changes in places this section does not own -- the floating cart
       drawer writes straight to /cart/change.js, and removing an item there used
       to leave the card stepper showing its old quantity until a reload.
       bxc-global.js re-broadcasts every cart mutation as `zz:cart`, and this
       reconciles the cards against it in BOTH directions: Add button -> stepper
       when a line appears, stepper -> Add button when the line is gone, and the
       number in between. Variants with a write of our own still in flight are
       skipped so this never fights the customer mid-tap. */
    var bxcBusy = {};
    function bxcBusyStart(vid) { bxcBusy[vid] = (bxcBusy[vid] || 0) + 1; }
    function bxcBusyEnd(vid) { bxcBusy[vid] = Math.max(0, (bxcBusy[vid] || 1) - 1); }
    function bxcApplyCart(cart) {
      if (!cart || !cart.items) return;
      var byVariant = {};
      cart.items.forEach(function (it) {
        var l = byVariant[it.variant_id];
        if (l) { l.quantity += it.quantity; } else { byVariant[it.variant_id] = { quantity: it.quantity, key: it.key }; }
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-bxc-add]'), function (btn) {
        var vid = btn.getAttribute('data-vid');
        if (!vid || bxcTimers[vid] || bxcBusy[vid]) return;
        var l = byVariant[vid];
        if (!l) return;
        var lbl = btn.querySelector('.bxc-add-lbl');
        bxcAddLabel[vid] = lbl ? lbl.innerHTML : btn.innerHTML;
        bxcLineKey[vid] = l.key;
        btn.replaceWith(bxcFrag(bxcQtyHTML(vid, l.quantity)));
      });
      Array.prototype.forEach.call(document.querySelectorAll('[data-bxc-qty]'), function (wrap) {
        var vid = wrap.getAttribute('data-vid');
        if (!vid || bxcTimers[vid] || bxcBusy[vid]) return;
        var l = byVariant[vid];
        if (l) {
          bxcLineKey[vid] = l.key;
          var n = wrap.querySelector('[data-bxc-n]');
          if (n && n.textContent !== String(l.quantity)) n.textContent = l.quantity;
        } else {
          bxcLineKey[vid] = null;
          wrap.replaceWith(bxcFrag(bxcAddBtnHTML(vid, bxcAddLabel[vid] || 'أضف')));
        }
      });
    }
    function bxcSyncCartQty() {
      if (!document.querySelector('[data-bxc-add], [data-bxc-qty]')) return;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(bxcApplyCart)
        .catch(function () {});
    }
    document.addEventListener('zz:cart', function (e) { if (e && e.detail) bxcApplyCart(e.detail); });

    function gridEl() { return document.getElementById('product-grid-container'); }
    function closeMenus() { document.querySelectorAll('[data-bxc-sortmenu], [data-bxc-switchmenu]').forEach(function (m) { m.hidden = true; }); }
    function openSide() { var s = document.querySelector('[data-bxc-side]'); var b = document.querySelector('[data-bxc-sidebackdrop]'); if (s) s.classList.add('is-open'); if (b) b.hidden = false; document.body.classList.add('bxc-noscroll'); }
    function closeSide() { var s = document.querySelector('[data-bxc-side]'); var b = document.querySelector('[data-bxc-sidebackdrop]'); if (s) s.classList.remove('is-open'); if (b) b.hidden = true; document.body.classList.remove('bxc-noscroll'); }
    function isMobile() { return window.matchMedia('(max-width: 768px)').matches; }
    function toggleFilter() { if (isMobile()) { openSide(); } else { var lay = document.querySelector('.bxc-layout'); if (lay) lay.classList.toggle('is-side-collapsed'); } }
    function scrollToTop() { var sec = document.querySelector('.bxc'); if (sec) window.scrollTo({ top: sec.offsetTop - 16, behavior: 'smooth' }); }

    /* Move viewport-fixed elements out of #MainContent onto <body>. A transformed
       ancestor (page transitions, animations) becomes the containing block for
       position:fixed and would pin the nav to the page instead of the screen. */
    function hoist(sel) {
      var els = Array.prototype.slice.call(document.querySelectorAll(sel));
      if (!els.length) return;
      var keep = null;
      els.forEach(function (el) { if (!el.hasAttribute('data-bxc-moved')) keep = el; });
      if (!keep) keep = els[0];
      els.forEach(function (el) { if (el !== keep && el.parentNode) el.parentNode.removeChild(el); });
      keep.setAttribute('data-bxc-moved', '1');
      if (keep.parentNode !== document.body) document.body.appendChild(keep);
    }

    function cardMatches(card) {
      if (state.rars.length) { var rar = card.getAttribute('data-rarity') || ''; if (state.rars.indexOf(rar) === -1) return false; }
      var price = parseFloat(card.getAttribute('data-price')) / 100;
      if (!isNaN(price)) { if (state.lo !== null && price < state.lo) return false; if (state.hi !== null && price > state.hi) return false; }
      return true;
    }

    /* ============ GRID RENDER (Oct 2026) ============
       Two views: shelves (category = all + sort = featured) or one flat grid (a category is
       picked and/or a sort is chosen). The cards are only re-ordered when the view, category
       or sort actually changes; price / rarity filters just show or hide cards. Before, every
       move of the price slider pulled all ~260 cards out of the page and put them back, which
       is why the slider lagged. Out-of-stock items always go last. */
    var view = null, flatKey = '', flatList = [];
    var orders = {};            /* sort name -> { handle: rank } (best-selling / newest, from the server) */
    var pageSort = 'manual';    /* the order the page itself was rendered in (?sort_by=) */
    function cardHandle(card) {
      if (card.__zzH !== undefined) return card.__zzH;
      var a = card.querySelector('a[href*="/products/"]');
      var h = '';
      if (a) { h = (a.getAttribute('href') || '').split('/products/')[1] || ''; h = h.split(/[?#]/)[0]; try { h = decodeURIComponent(h); } catch (x) {} }
      card.__zzH = h;
      return h;
    }
    function isOos(card) { return !!card.querySelector('.bxc-card__oos'); }
    function rankOf(card) {
      var s = state.sort;
      if (s === 'manual' || s === pageSort) return card.__zzIdx || 0;
      var o = orders[s];
      if (o) { var r = o[cardHandle(card)]; return r === undefined ? 100000 + (card.__zzIdx || 0) : r; }
      return card.__zzIdx || 0;
    }
    function sortCards(list) {
      var s = state.sort;
      return list.slice().sort(function (x, y) {
        var ox = isOos(x) ? 1 : 0, oy = isOos(y) ? 1 : 0;
        if (ox !== oy) return ox - oy;
        if (s === 'price-ascending' || s === 'price-descending') {
          var px = parseFloat(x.getAttribute('data-price')) || 0, py = parseFloat(y.getAttribute('data-price')) || 0;
          if (px !== py) return s === 'price-ascending' ? px - py : py - px;
          return (x.__zzIdx || 0) - (y.__zzIdx || 0);
        }
        return rankOf(x) - rankOf(y);
      });
    }
    function setShown(card, ok) {
      var want = ok ? '' : 'none';
      if (card.style.display !== want) card.style.display = want;
    }
    function updateProductGrid() {
      var c = gridEl(); if (!c) return;
      var shown = 0;
      var flat = !(state.cat === '__all' && state.sort === 'manual');
      if (!flat) {
        if (view !== 'shelves') {
          c.classList.remove('is-flat');
          c.textContent = '';
          var fr = document.createDocumentFragment();
          lanes.forEach(function (L) {
            L.row.textContent = '';
            L.cards.forEach(function (card) { L.row.appendChild(card); });
            fr.appendChild(L.el);
          });
          c.appendChild(fr);
          view = 'shelves'; flatKey = '';
        }
        lanes.forEach(function (L) {
          var vis = 0;
          L.cards.forEach(function (card) { var ok = cardMatches(card); setShown(card, ok); if (ok) vis++; });
          var d = vis ? '' : 'none';
          if (L.el.style.display !== d) L.el.style.display = d;
          shown += vis;
        });
      } else {
        var key = state.cat + '|' + state.sort + '|' + (orders[state.sort] ? 1 : 0);
        if (view !== 'flat' || flatKey !== key) {
          var list = [];
          lanes.forEach(function (L) { if (state.cat === '__all' || L.word === state.cat) list = list.concat(L.cards); });
          flatList = sortCards(list);
          c.textContent = '';
          c.classList.add('is-flat');
          var fr2 = document.createDocumentFragment();
          flatList.forEach(function (card) { fr2.appendChild(card); });
          c.appendChild(fr2);
          view = 'flat'; flatKey = key;
        }
        flatList.forEach(function (card) { var ok = cardMatches(card); setShown(card, ok); if (ok) shown++; });
      }
      var empty = document.querySelector('[data-bxc-empty]'); if (empty) empty.classList.toggle('is-shown', shown === 0);
    }
    var gridQueued = false;
    function queueGrid() {
      if (gridQueued) return;
      gridQueued = true;
      requestAnimationFrame(function () { gridQueued = false; updateProductGrid(); });
    }

    /* ============ SORT (Oct 2026) — applied in the page, keeps the chosen category ============
       Price sorts use the prices already on the cards. Best-selling and newest ask the store for
       that order once (a few KB: just the product handles) and cache it. Leaving the page and
       coming back starts from the featured order again. */
    var SORTS = ['manual', 'best-selling', 'price-ascending', 'price-descending', 'created-descending'];
    var orderLoads = {};
    function loadOrder(sort) {
      if (orders[sort] || sort === pageSort) return Promise.resolve();
      if (orderLoads[sort]) return orderLoads[sort];
      var url = location.pathname + '?sort_by=' + encodeURIComponent(sort) + '&section_id=zz-sort-order';
      orderLoads[sort] = fetch(url, { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var m = html.match(/<script[^>]*data-zz-order[^>]*>([\s\S]*?)<\/script>/);
          var arr = m ? JSON.parse(m[1]) : null;
          if (arr && arr.length) { var map = {}; arr.forEach(function (h, i) { map[h] = i; }); orders[sort] = map; }
        })
        .catch(function () {})
        .then(function () { orderLoads[sort] = null; });
      return orderLoads[sort];
    }
    function sortFromLink(a) {
      var h = a.getAttribute('href') || '';
      var m = h.match(/sort_by=([a-z-]+)/);
      return m && SORTS.indexOf(m[1]) !== -1 ? m[1] : null;
    }
    function markSort() {
      document.querySelectorAll('[data-bxc-sortmenu] a').forEach(function (a) {
        var on = sortFromLink(a) === state.sort;
        a.classList.toggle('is-active', on);
        if (on) a.setAttribute('aria-current', 'true'); else a.removeAttribute('aria-current');
      });
      document.querySelectorAll('[data-bxc-sortbtn]').forEach(function (b) {
        if (!b.__zzLbl) { var sp = b.querySelector('span'); b.__zzLbl = sp; b.__zzDef = sp ? sp.textContent : ''; }
        if (!b.__zzLbl) return;
        var act = document.querySelector('[data-bxc-sortmenu] a.is-active');
        b.__zzLbl.textContent = (state.sort !== 'manual' && act) ? act.textContent : b.__zzDef;
        b.classList.toggle('is-sorted', state.sort !== 'manual');
      });
    }
    function applySort(sort) {
      if (!sort) return;
      state.sort = sort;
      markSort();
      loadOrder(sort).then(function () { if (state.sort === sort) { updateProductGrid(); scrollToTop(); } });
    }

    /* ============ UNIFIED CATEGORY FILTER — pills, bottom nav, and عرض الكل ============ */
    function filterCategory(categoryName) {
      state.cat = categoryName;
      document.querySelectorAll('[data-bxc-filter]').forEach(function (x) {
        var on = x.getAttribute('data-bxc-filter') === categoryName;
        if (x.classList.contains('bxc-shelf__all')) { x.classList.remove('is-active'); return; }
        x.classList.toggle('is-active', on);
        if (on) { var bar = x.closest('.bxc-catnav__inner, .bxc-bottomnav'); if (bar && bar.scrollTo) { bar.scrollTo({ left: x.offsetLeft - bar.clientWidth / 2 + x.clientWidth / 2, behavior: 'smooth' }); } }
      });
      updateProductGrid();
      closeSide();
      scrollToTop();
    }

    function initRange() {
      var wrap = document.querySelector('[data-bxc-range]'); if (!wrap || wrap.dataset.bound) return; wrap.dataset.bound = '1';
      var min = parseFloat(wrap.getAttribute('data-min')) || 0; var max = parseFloat(wrap.getAttribute('data-max')) || 0;
      var rmin = wrap.querySelector('[data-bxc-rmin]'); var rmax = wrap.querySelector('[data-bxc-rmax]'); var fill = wrap.querySelector('[data-bxc-fill]');
      var nmin = document.querySelector('[data-bxc-nmin]'); var nmax = document.querySelector('[data-bxc-nmax]');
      function clamp(val) { if (isNaN(val)) val = min; if (val < min) val = min; if (val > max) val = max; return val; }
      function upd() {
        var a = parseFloat(rmin.value); var b = parseFloat(rmax.value); if (a > b) { var t = a; a = b; b = t; }
        var span = (max - min) || 1; var p1 = ((a - min) / span) * 100; var p2 = ((b - min) / span) * 100;
        if (fill) { fill.style.insetInlineStart = p1 + '%'; fill.style.insetInlineEnd = (100 - p2) + '%'; }
        if (nmin && document.activeElement !== nmin) nmin.value = Math.round(a);
        if (nmax && document.activeElement !== nmax) nmax.value = Math.round(b);
        state.lo = a; state.hi = b;
      }
      rmin.addEventListener('input', function () { if (parseFloat(rmin.value) > parseFloat(rmax.value)) rmin.value = rmax.value; upd(); queueGrid(); });
      rmax.addEventListener('input', function () { if (parseFloat(rmax.value) < parseFloat(rmin.value)) rmax.value = rmin.value; upd(); queueGrid(); });
      if (nmin) nmin.addEventListener('change', function () { var val = clamp(parseFloat(nmin.value)); if (val > parseFloat(rmax.value)) val = parseFloat(rmax.value); rmin.value = val; upd(); updateProductGrid(); });
      if (nmax) nmax.addEventListener('change', function () { var val = clamp(parseFloat(nmax.value)); if (val < parseFloat(rmin.value)) val = parseFloat(rmin.value); rmax.value = val; upd(); updateProductGrid(); });
      upd();
    }
    function resetFilters() {
      document.querySelectorAll('.bxc-rar.is-on').forEach(function (p) { p.classList.remove('is-on'); });
      state.rars = [];
      var wrap = document.querySelector('[data-bxc-range]');
      if (wrap) { var rmin = wrap.querySelector('[data-bxc-rmin]'); var rmax = wrap.querySelector('[data-bxc-rmax]'); rmin.value = rmin.min; rmax.value = rmax.max; rmin.dispatchEvent(new Event('input')); rmax.dispatchEvent(new Event('input')); }
      else { updateProductGrid(); }
    }
    function findCartIcon() { return document.querySelector('#cart-icon-bubble') || document.querySelector('a[href$="/cart"]') || document.querySelector('a[href*="/cart"]') || document.querySelector('[data-cart-icon]'); }
    function floatPlusOne() {
      var icon = findCartIcon(); var el = document.createElement('div'); el.className = 'bxc-plusone'; el.textContent = '+1'; document.body.appendChild(el);
      if (icon) { var r = icon.getBoundingClientRect(); el.style.left = (r.left + r.width / 2) + 'px'; el.style.top = (r.top + 4) + 'px'; } else { el.style.left = '50%'; el.style.top = '76px'; }
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-go'); }); });
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 900);
    }
    document.addEventListener('click', function (e) {
      var sl = e.target.closest('[data-bxc-sortmenu] a');
      if (sl && sortFromLink(sl)) { e.preventDefault(); closeMenus(); applySort(sortFromLink(sl)); return; }
      var so = e.target.closest('[data-bxc-sortbtn]');
      if (so) {
        var m = so.parentNode.querySelector('[data-bxc-sortmenu]'); var was = m.hidden; closeMenus(); m.hidden = !was; e.stopPropagation();
        if (was) { loadOrder('best-selling'); loadOrder('created-descending'); }   /* ready before the visitor picks */
        return;
      }
      var sb = e.target.closest('[data-bxc-switchbtn]');
      if (sb) { var m2 = sb.parentNode.querySelector('[data-bxc-switchmenu]'); var was2 = m2.hidden; closeMenus(); m2.hidden = !was2; e.stopPropagation(); return; }
      if (e.target.closest('[data-bxc-toggle-filter]')) { toggleFilter(); closeMenus(); return; }
      if (e.target.closest('[data-bxc-closeside]')) { closeSide(); return; }
      if (e.target.closest('[data-bxc-resetfilters]')) { resetFilters(); return; }
      if (e.target.closest('[data-bxc-applyfilters]')) { closeSide(); return; }
      var gm = e.target.closest('[data-bxc-gamesmore]');
      if (gm) { var grid = document.querySelector('[data-bxc-games]'); var lbl = gm.querySelector('[data-bxc-gamesmore-lbl]'); if (grid) { grid.classList.toggle('is-collapsed'); gm.classList.toggle('is-open'); if (lbl) lbl.textContent = grid.classList.contains('is-collapsed') ? 'عرض أكثر' : 'عرض أقل'; } return; }
      var rp = e.target.closest('[data-bxc-rar]');
      if (rp) { rp.classList.toggle('is-on'); state.rars = []; document.querySelectorAll('.bxc-rar.is-on').forEach(function (p) { state.rars.push(p.getAttribute('data-bxc-rar')); }); updateProductGrid(); return; }
      var addBtn = e.target.closest('[data-bxc-add]');
      if (addBtn && !addBtn.disabled) {
        e.preventDefault(); var aid = addBtn.getAttribute('data-vid'); if (!aid) return;
        var awant = bxcWantQty(aid, addBtn.closest('.bxc-card'));
        var lbl0 = addBtn.querySelector('.bxc-add-lbl');
        bxcAddLabel[aid] = lbl0 ? lbl0.innerHTML : addBtn.innerHTML;
        addBtn.replaceWith(bxcFrag(bxcQtyHTML(aid, awant)));
        floatPlusOne();
        /* No parallel /cart.js kick here any more. Fired at click time it raced
           the write and could land first, committing a pre-add snapshot that
           visibly rolled the pill count backwards before correcting itself.
           The write below returns the whole cart, so there is nothing to chase. */
        bxcStartLine(aid, awant);
        return;
      }
      var plusBtn = e.target.closest('[data-bxc-plus]');
      if (plusBtn) {
        e.preventDefault();
        var wrap = plusBtn.closest('[data-bxc-qty]'); if (!wrap) return;
        var pvid = wrap.getAttribute('data-vid');
        var n = wrap.querySelector('[data-bxc-n]');
        var next = (parseInt(n.textContent, 10) || 1) + 1;
        n.textContent = next;
        floatPlusOne();
        bxcDebounceChange(pvid, next);
        return;
      }
      var minusBtn = e.target.closest('[data-bxc-minus]');
      if (minusBtn) {
        e.preventDefault();
        var wrap2 = minusBtn.closest('[data-bxc-qty]'); if (!wrap2) return;
        var tvid = wrap2.getAttribute('data-vid');
        var n2 = wrap2.querySelector('[data-bxc-n]');
        var cur = parseInt(n2.textContent, 10) || 1;
        if (cur > 1) {
          /* Step down. Debounced like the plus button, so a run of taps sends
             one request instead of one per tap. */
          n2.textContent = cur - 1;
          bxcDebounceChange(tvid, cur - 1);
        } else {
          /* Last one out: drop the line and restore the Add button. */
          wrap2.replaceWith(bxcFrag(bxcAddBtnHTML(tvid, bxcAddLabel[tvid] || 'أضف')));
          bxcImmediateChange(tvid, 0);
        }
        return;
      }
      var f = e.target.closest('[data-bxc-filter]');
      if (f) { e.preventDefault(); filterCategory(f.getAttribute('data-bxc-filter')); return; }
      var s = e.target.closest('[data-bxc-scroll]');
      if (s) { var scr = s.closest('.bxc-shelf__scroller'); var row = scr && scr.querySelector('[data-bxc-row]'); if (row) { var dir = parseInt(s.getAttribute('data-bxc-scroll'), 10) || 1; row.scrollBy({ left: dir * row.clientWidth * 0.8, behavior: 'smooth' }); } return; }
      if (!e.target.closest('[data-bxc-sortmenu], [data-bxc-switchmenu]')) closeMenus();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMenus(); closeSide(); } });
    function init() {
      hoist('.bxc-bottomnav');
      hoist('[data-bxc-sidebackdrop]');
      initRange();
      var c = gridEl();
      if (c && !c.dataset.bound) {
        c.dataset.bound = '1';
        lanes = [];
        var byWord = {}, idx = 0;
        c.querySelectorAll('[data-bxc-shelf]').forEach(function (el) {
          var row = el.querySelector('[data-bxc-row]');
          if (!row) return;
          var cards = Array.prototype.slice.call(row.children);
          cards.forEach(function (card) { card.__zzIdx = idx++; });
          var word = el.getAttribute('data-bxc-shelf');
          /* a page opened with ?sort_by= used to split one category into many small shelves */
          if (byWord[word]) {
            cards.forEach(function (card) { byWord[word].row.appendChild(card); });
            byWord[word].cards = byWord[word].cards.concat(cards);
            if (el.parentNode) el.parentNode.removeChild(el);
            return;
          }
          var L = { el: el, word: word, row: row, cards: cards };
          byWord[word] = L;
          lanes.push(L);
        });
        var sp = null;
        try { sp = new URLSearchParams(location.search).get('sort_by'); } catch (x) {}
        if (sp && SORTS.indexOf(sp) !== -1 && sp !== 'manual') { pageSort = sp; state.sort = sp; markSort(); updateProductGrid(); }
      }
    }
    /* Oct 2026: a link ending in #cat-<word> (the category in the product page's path bar) opens
       the page on that category, like pressing its pill — without the scroll jump. */
    function openFromHash() {
      var m = (location.hash || '').match(/^#cat-(.+)$/);
      if (!m) return;
      var word = '';
      try { word = decodeURIComponent(m[1].replace(/\+/g, ' ')); } catch (x) { return; }
      var ok = false;
      lanes.forEach(function (L) { if (L.word === word) ok = true; });
      if (!ok) return;
      state.cat = word;
      document.querySelectorAll('[data-bxc-filter]').forEach(function (x) {
        if (x.classList.contains('bxc-shelf__all')) { x.classList.remove('is-active'); return; }
        var on = x.getAttribute('data-bxc-filter') === word;
        x.classList.toggle('is-active', on);
        if (on) { var bar = x.closest('.bxc-catnav__inner, .bxc-bottomnav'); if (bar) bar.scrollLeft = x.offsetLeft - bar.clientWidth / 2 + x.clientWidth / 2; }
      });
      updateProductGrid();
    }
    function initAll() { init(); openFromHash(); }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', initAll); } else { initAll(); }
    window.addEventListener('hashchange', openFromHash);
    document.addEventListener('shopify:section:load', init);
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', bxcSyncCartQty); } else { bxcSyncCartQty(); }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dynamic-best-sellers"] && !Shopify.designMode) return;
  try {
    
(function(){
  function activate(root, key){
    var pills = root.querySelectorAll('[data-dbs-tab]');
    var panels = root.querySelectorAll('[data-dbs-panel]');
    Array.prototype.forEach.call(pills, function(p){
      var on = p.getAttribute('data-dbs-tab') === key;
      p.classList.toggle('is-active', on);
      p.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    Array.prototype.forEach.call(panels, function(pn){
      pn.classList.toggle('is-active', pn.getAttribute('data-dbs-panel') === key);
    });
  }
  function init(root){
    var roots = (root || document).querySelectorAll('.dbs');
    Array.prototype.forEach.call(roots, function(s){
      if(s.dataset.dbsInit === '1') return; s.dataset.dbsInit = '1';
      var pills = s.querySelectorAll('[data-dbs-tab]');
      Array.prototype.forEach.call(pills, function(p){
        p.addEventListener('click', function(){ activate(s, p.getAttribute('data-dbs-tab')); });
      });
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); }); else init(document);
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  document.addEventListener('shopify:block:select', function(e){
    var root = e.target.closest && e.target.closest('.dbs'); if(!root) return;
    var key = e.target.getAttribute && e.target.getAttribute('data-dbs-tab');
    if(!key){ var el = e.target.querySelector && e.target.querySelector('[data-dbs-tab]'); if(el) key = el.getAttribute('data-dbs-tab'); }
    if(key) activate(root, key);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["farm-qty"] && !Shopify.designMode) return;
  try {
    
  (function(){
    function parseMoney(str){
      if(!str){ return null; }
      var first = -1, last = -1, i, c;
      for(i = 0; i < str.length; i++){ c = str.charCodeAt(i); if(c >= 48 && c <= 57){ if(first < 0){ first = i; } last = i; } }
      if(first < 0){ return null; }
      var pre = str.slice(0, first);
      var suf = str.slice(last + 1);
      var mid = str.slice(first, last + 1);
      var hasDot = mid.indexOf('.') >= 0, hasComma = mid.indexOf(',') >= 0;
      var clean = '', dec = 0, seenDot = false, j, ch;
      for(j = 0; j < mid.length; j++){
        ch = mid.charAt(j);
        if(ch >= '0' && ch <= '9'){ clean += ch; if(seenDot){ dec++; } }
        else if(ch === '.'){ if(hasDot){ clean += '.'; seenDot = true; } }
        else if(ch === ','){ if(hasComma && !hasDot){ clean += '.'; seenDot = true; } }
      }
      var num = parseFloat(clean);
      if(isNaN(num)){ return null; }
      return { num: num, pre: pre, suf: suf, dec: dec };
    }
    function group(intStr){
      var out = '', c = 0, i;
      for(i = intStr.length - 1; i >= 0; i--){ out = intStr.charAt(i) + out; c++; if(c % 3 === 0 && i > 0){ out = ',' + out; } }
      return out;
    }
    function fmt(num, ref){
      var s = num.toFixed(ref.dec);
      var dot = s.indexOf('.');
      var ip = dot >= 0 ? s.slice(0, dot) : s;
      var fp = dot >= 0 ? s.slice(dot) : '';
      return ref.pre + group(ip) + fp + ref.suf;
    }
    function init(){
      var root = document.querySelector('[data-fqty]');
      if(!root){ return; }
      var info = document.querySelector('.bxp-info');
      if(info && root.parentNode !== info){
        var anchor = document.querySelector('.bxp-qty');
        if(anchor){ info.insertBefore(root, anchor); }
        else { var wa = info.querySelector('.bxp-wa'); if(wa){ info.insertBefore(root, wa); } else { info.appendChild(root); } }
      }
      var min = parseInt(root.getAttribute('data-min'), 10) || 1;
      var vid = root.getAttribute('data-vid');
      var input = root.querySelector('[data-fqty-input]');
      var totalEl = root.querySelector('[data-fqty-total]');
      var srcEl = root.querySelector('[data-fqty-unit]');
      var addBtn = root.querySelector('[data-fqty-add]');
      var qty = min;
      function unitText(){
        var n = document.querySelector('[data-bxp-now]');
        if(n){ var t = (n.textContent || '').trim(); if(t){ return t; } }
        if(srcEl){ return (srcEl.textContent || '').trim(); }
        return '';
      }
      function render(){
        if(input){ input.value = qty; }
        if(totalEl){
          var ref = parseMoney(unitText());
          if(ref){ totalEl.textContent = fmt(ref.num * qty, ref); }
        }
      }
      function setQty(n){ if(isNaN(n) || n < min){ n = min; } qty = Math.floor(n); render(); }
      root.addEventListener('click', function(e){
        if(e.target.closest('[data-fqty-minus]')){ setQty(qty - 1); }
        else if(e.target.closest('[data-fqty-plus]')){ setQty(qty + 1); }
        else if(e.target.closest('[data-fqty-buy]')){ go(true); }
        else if(e.target.closest('[data-fqty-add]')){ go(false); }
      });
      if(input){
        input.addEventListener('change', function(){ setQty(parseInt(input.value, 10)); });
        input.addEventListener('blur', function(){ setQty(parseInt(input.value, 10)); });
      }
      function go(checkout){
        fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] }) })
        .then(function(r){ if(!r.ok){ throw new Error('add'); } return r.json(); })
        .then(function(){ if(checkout){ window.location.href = '/checkout'; } else { if(addBtn){ addBtn.classList.add('is-done'); setTimeout(function(){ addBtn.classList.remove('is-done'); }, 1200); } document.dispatchEvent(new CustomEvent('bxc:cart-updated')); } })
        .catch(function(){});
      }
      var watch = document.querySelector('[data-bxp-now]') || srcEl;
      if(watch && typeof MutationObserver !== 'undefined'){
        var mo = new MutationObserver(function(){ render(); });
        mo.observe(watch, { childList: true, subtree: true, characterData: true });
      }
      render();
      setTimeout(render, 400);
      setTimeout(render, 1200);
    }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();
  (function(){
    function initBogo(){
      var b = document.querySelector('[data-bxgo]');
      if(!b){ return; }
      var info = document.querySelector('.bxp-info');
      if(info && b.parentNode !== info){
        var anchor = document.querySelector('.bxp-qty') || document.querySelector('.bxp-ctas');
        if(anchor){ info.insertBefore(b, anchor); } else { info.appendChild(b); }
      }
    }
    if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', initBogo); } else { initBogo(); }
    document.addEventListener('shopify:section:load', initBogo);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["how-to-receive"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    var sections=(root||document).querySelectorAll('.zilzal-htr');
    Array.prototype.forEach.call(sections,function(s){
      if(s.dataset.htrInit==='1') return; s.dataset.htrInit='1';
      var cards=s.querySelectorAll('.zilzal-htr__card');
      if(!cards.length) return;
      var reduce=window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      if(reduce || !('IntersectionObserver' in window)) return;
      s.classList.add('htr-anim');
      var io=new IntersectionObserver(function(en){en.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });},{threshold:0.15});
      Array.prototype.forEach.call(cards,function(c,i){ c.style.transitionDelay=(i*0.09)+'s'; io.observe(c); });
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target);});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-with-text-blocks"] && !Shopify.designMode) return;
  try {
    
(function(){
  function prime(m){ if(m && !m.classList.contains('is-primed')) m.classList.add('is-primed'); }
  function primeAll(){ Array.prototype.forEach.call(document.querySelectorAll('[data-zh-modal]'), prime); }
  function openModal(m){ prime(m); m.classList.add('is-open'); m.setAttribute('aria-hidden','false'); document.body.classList.add('zh-noscroll'); }
  function closeModal(m){ m.classList.remove('is-open'); m.setAttribute('aria-hidden','true'); document.body.classList.remove('zh-noscroll'); }
  function bindModal(m){
    var overlay=m.querySelector('[data-zh-modal-overlay]');
    var panel=m.querySelector('[data-zh-modal-panel]');
    var closeBtn=m.querySelector('[data-zh-modal-close]');
    if(overlay) overlay.addEventListener('click',function(){ closeModal(m); });
    if(closeBtn) closeBtn.addEventListener('click',function(){ closeModal(m); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape' && m.classList.contains('is-open')) closeModal(m); });
    if(panel){
      var sy=0, touching=false, atTop=true;
      panel.addEventListener('touchstart',function(e){ touching=true; sy=e.touches[0].clientY; atTop=(panel.scrollTop<=0); panel.style.transition='none'; },{passive:true});
      panel.addEventListener('touchmove',function(e){ if(!touching||!atTop) return; var dy=e.touches[0].clientY-sy; if(dy>0) panel.style.transform='translateY('+dy+'px)'; },{passive:true});
      panel.addEventListener('touchend',function(e){ if(!touching) return; touching=false; panel.style.transition=''; var dy=e.changedTouches[0].clientY-sy; panel.style.transform=''; if(atTop && dy>100) closeModal(m); },{passive:true});
    }
  }
  function initModals(root){
    var modals=(root||document).querySelectorAll('.zilzal-hero-wrapper [data-zh-modal]');
    Array.prototype.forEach.call(modals,function(modal){
      var sid=modal.getAttribute('data-zh-sid');
      var stale=document.querySelectorAll('body > [data-zh-modal][data-zh-sid="'+sid+'"]');
      Array.prototype.forEach.call(stale,function(x){ if(x!==modal && x.parentNode) x.parentNode.removeChild(x); });
      if(modal.parentNode!==document.body){ document.body.appendChild(modal); }
      if(modal.dataset.zhBound!=='1'){ modal.dataset.zhBound='1'; bindModal(modal); }
    });
    var triggers=(root||document).querySelectorAll('[data-zh-open-modal]');
    Array.prototype.forEach.call(triggers,function(t){
      if(t.dataset.zhBound==='1') return; t.dataset.zhBound='1';
      function target(){ return document.querySelector('[data-zh-modal][data-zh-sid="'+t.getAttribute('data-zh-target')+'"]'); }
      t.addEventListener('click',function(e){ e.preventDefault(); var m=target(); if(m) openModal(m); });
      ['pointerenter','touchstart','focus'].forEach(function(ev){ t.addEventListener(ev,function(){ prime(target()); },{passive:true,once:true}); });
    });
  }
  function init(){ initModals(document); }
  /* only when a button can open the modal (the primary button may be set to a plain link instead) */
  function idlePrime(){ if(!document.querySelector('[data-zh-open-modal]')) return; setTimeout(function(){ (window.requestIdleCallback || function(f){ setTimeout(f, 1); })(primeAll); }, 2500); }
  if(document.readyState==='complete') idlePrime(); else window.addEventListener('load', idlePrime);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-bxc"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var VD = [];
    var cart = null, inCart = 0, shown = null, pend = 0, timer = null, busy = false;

    function ctas() { return document.querySelector('[data-bxp-ctas]'); }
    function curVid() { var a = document.querySelector('[data-bxp-add]'); return a ? a.getAttribute('data-vid') : null; }
    function stepperOn() { var c = ctas(); return !!(c && c.getAttribute('data-stepper') === '1'); }
    function vdata(id) { for (var i = 0; i < VD.length; i++) { if (String(VD[i].id) === String(id)) return VD[i]; } return null; }
    function readVariants() {
      var el = document.querySelector('[data-bxp-vdata]');
      if (!el) return;
      try { VD = JSON.parse(el.textContent); } catch (e) { VD = []; }
    }

    /* ---------- add-to-cart <-> cart quantity ---------- */
    function paint(q) {
      var c = ctas(); if (!c) return;
      var on = stepperOn() && q > 0;
      c.classList.toggle('is-incart', on);
      c.classList.toggle('is-one', q <= 1);
      var val = c.querySelector('[data-bxp-qval]'); if (val) val.textContent = q;
      var minus = c.querySelector('[data-bxp-qminus]');
      if (minus) minus.setAttribute('aria-label', minus.getAttribute(q <= 1 ? 'data-l-remove' : 'data-l-minus') || '');
      var plus = c.querySelector('[data-bxp-qplus]'), d = vdata(curVid());
      if (plus) plus.disabled = !!(d && d.m > 0 && q >= d.m);
    }
    function lineOf(c, id) {
      var q = 0;
      ((c && c.items) || []).forEach(function (it) { if (String(it.variant_id) === String(id)) q += it.quantity; });
      return { q: q };
    }
    function sync(c) {
      if (c && typeof c.item_count !== 'undefined') cart = c;
      if (!cart || timer || busy || pend) return;
      inCart = lineOf(cart, curVid()).q; shown = null;
      paint(inCart);
    }
    /* Changes are sent as differences (+n with /cart/add.js, -n taken off the newest lines with
       /cart/update.js), never as "set to N": the gift/discount engine can split one item into two
       cart lines at any moment, and a difference stays correct whatever the lines look like. */
    function flush() {
      timer = null;
      var id = curVid(), d = pend; pend = 0;
      if (!id || !d) { shown = null; sync(); return; }
      var req;
      if (d > 0) {
        req = fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: d }] }) });
      } else {
        var need = -d, upd = {}, n = 0;
        var lines = ((cart && cart.items) || []).filter(function (it) { return String(it.variant_id) === String(id); });
        for (var i = lines.length - 1; i >= 0 && need > 0; i--) { var take = Math.min(need, lines[i].quantity); upd[lines[i].key] = lines[i].quantity - take; need -= take; n++; }
        if (!n) { shown = null; sync(); return; }
        req = fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ updates: upd }) });
      }
      busy = true;
      req.then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }, function () { return { ok: false }; }); })
        .then(function (res) {
          busy = false;
          if (res.ok && res.j && typeof res.j.item_count !== 'undefined') { sync(res.j); }
          else if (window.zzCartRefresh) { window.zzCartRefresh(); }   /* add.js answers with the item only: the refresh brings the cart */
        })
        .catch(function () { busy = false; if (window.zzCartRefresh) window.zzCartRefresh(); });
    }
    /* Oct 2026: the floating pill moves on the tap (count, total and the picture drop),
       see snippets/zz-floating-cart.liquid. imm = send now (first add) instead of batching. */
    function bump(delta, imm, img) {
      var base = shown != null ? shown : inCart;
      var n = Math.max(0, base + delta), d = vdata(curVid());
      if (d && d.m > 0 && n > d.m) n = d.m;
      var step = n - base;
      if (step && window.zzCartFx) window.zzCartFx.add({ n: step, c: step * ((d && d.c) || 0), img: step > 0 ? img : null });
      pend += step; shown = n; paint(n);
      clearTimeout(timer); timer = setTimeout(flush, imm ? 0 : 300);
    }
    function minFor(vid) { var m = 0; try { m = (window.__zzMinForKey && window.__zzMinForKey(String(vid))) || 0; } catch (e) { m = 0; } return m > 1 ? m : 1; }
    function postAdd(vid, n) {
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: n }] }) })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
    }

    /* ---------- variants ---------- */
    function applyVariant(vid) {
      var d = vdata(vid);
      if (!d) return;
      document.querySelectorAll('[data-bxp-now]').forEach(function (n) { n.textContent = d.n; });
      document.querySelectorAll('[data-bxp-was]').forEach(function (w) { if (d.w) { w.textContent = d.w; w.hidden = false; } else { w.hidden = true; } });
      document.querySelectorAll('[data-bxp-disc]').forEach(function (p) { if (d.p > 0) { p.textContent = '-' + d.p + '%'; p.hidden = false; } else { p.hidden = true; } });
      document.querySelectorAll('[data-bxp-add], [data-bxp-buynow]').forEach(function (b) { b.setAttribute('data-vid', d.id); b.disabled = !d.a; b.classList.toggle('is-disabled', !d.a); });
      var st = document.querySelector('[data-bxp-stock]');
      if (st) { if (d.q > 0) { st.textContent = (st.getAttribute('data-tpl') || '').replace('[n]', d.q); st.hidden = false; } else { st.hidden = true; } }
      clearTimeout(timer); timer = null; pend = 0; shown = null;
      sync();
    }

    /* ---------- short description: 2 lines + read more ---------- */
    function initSum() {
      var s = document.querySelector('[data-bxp-sum]'); if (!s) return;
      var t = s.querySelector('.bxp-sum__txt'), b = s.querySelector('[data-bxp-more]');
      if (!t || !b) return;
      var over = t.scrollHeight > t.clientHeight + 4;
      s.classList.toggle('is-clamped', over && !s.classList.contains('is-open'));
      b.hidden = !over && !s.classList.contains('is-open');
    }

    function bind() {
      if (window.__bxpBound) return;
      window.__bxpBound = true;
      document.addEventListener('zz:cart', function (e) { sync(e.detail); });
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-bxp-thumb]');
        if (t) { var main = document.querySelector('[data-bxp-main]'); if (main) main.src = t.getAttribute('data-src'); document.querySelectorAll('[data-bxp-thumb]').forEach(function (x) { x.classList.toggle('is-on', x === t); }); return; }
        if (e.target.closest('[data-bxp-qplus]')) { if (!e.target.closest('[data-bxp-qplus]').disabled) bump(1); return; }
        if (e.target.closest('[data-bxp-qminus]')) { bump(-1); return; }
        var mo = e.target.closest('[data-bxp-more]');
        if (mo) {
          var s = mo.closest('[data-bxp-sum]'); var open = !s.classList.contains('is-open');
          s.classList.toggle('is-open', open); s.classList.toggle('is-clamped', !open);
          mo.textContent = mo.getAttribute(open ? 'data-less' : 'data-more'); mo.setAttribute('aria-expanded', open ? 'true' : 'false');
          return;
        }
        var a = e.target.closest('[data-bxp-add]');
        if (a && !a.disabled) {
          if (a.classList.contains('is-loading') || a.classList.contains('is-done')) return;
          var avid = a.getAttribute('data-vid'); if (!avid) return;
          /* a quantity change is still on its way: count this tap into it instead of a second request */
          if (stepperOn() && (timer || busy || shown != null)) { bump(1); return; }
          /* Oct 2026: the stepper appears on the tap (BloxCart-style) and the request goes out at once;
             if it fails, the cart refresh puts the button back. */
          if (stepperOn()) { bump(minFor(avid), true, document.getElementById('zz-pimg')); return; }
          var ad = vdata(avid);
          if (window.zzCartFx) window.zzCartFx.add({ n: 1, c: (ad && ad.c) || 0, img: document.getElementById('zz-pimg') });
          a.classList.add('is-loading');
          postAdd(avid, 1).then(function () {
            a.classList.remove('is-loading');
            if (stepperOn()) { inCart += 1; paint(inCart); }
            else { a.classList.add('is-done'); setTimeout(function () { a.classList.remove('is-done'); }, 1200); }
            document.dispatchEvent(new CustomEvent('bxc:cart-updated'));
          }).catch(function () { a.classList.remove('is-loading'); });
          return;
        }
        var bn = e.target.closest('[data-bxp-buynow]');
        if (bn && !bn.disabled) {
          if (bn.classList.contains('is-loading')) return;
          var bvid = bn.getAttribute('data-vid'); if (!bvid) return;
          bn.classList.add('is-loading');
          var go = function () { window.location.href = '/checkout'; };
          if (stepperOn() && (inCart > 0 || (shown != null && shown > 0))) {
            if (timer) { clearTimeout(timer); flush(); setTimeout(go, 450); } else { go(); }
            return;
          }
          postAdd(bvid, 1).then(go).catch(function () { bn.classList.remove('is-loading'); });
          return;
        }
      });
      document.addEventListener('change', function (e) {
        var s = e.target.closest('[data-bxp-variant]');
        if (s) applyVariant(s.value);
      });
      window.addEventListener('pageshow', function (e) { if (e.persisted) { document.querySelectorAll('[data-bxp-buynow].is-loading').forEach(function (b) { b.classList.remove('is-loading'); }); if (window.zzCartRefresh) window.zzCartRefresh(); } });
    }

    function init() {
      if (!document.querySelector('.bxp-info')) return;
      bind();
      readVariants();
      initSum();
      if (window.zzCartRefresh) { var p = window.zzCartRefresh(); if (p && p.then) p.then(function (c) { sync(c); }); }
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
    document.addEventListener('shopify:section:load', init);
  })();

  } catch(e) { console.error(e); }
})();
})();
